import { TabsTrigger } from "@/components/atoms"
import LocalizedClientLink from "@/components/molecules/LocalizedLink/LocalizedLink"

interface TabItem {
  label: string
  link: string
  value?: string
}

export const TabsList = ({
  list,
  activeTab,
}: {
  list: TabItem[]
  activeTab: string
}) => {
  return (
    <div className="flex gap-4 w-full border-b">
      {list.map(({ value, label, link }) => (
        <LocalizedClientLink key={value || label} href={link}>
          <TabsTrigger isActive={activeTab === (value || label.toLowerCase())}>
            {label}
          </TabsTrigger>
        </LocalizedClientLink>
      ))}
    </div>
  )
}
